import { Component, OnInit, ViewChild } from '@angular/core';
import { map } from 'rxjs/operators';
import { TarifCodeService } from 'src/app/shared/services/tarif-code.service';
import { TypePrestationService } from '../../shared/services/type-prestation.service';

@Component({
  selector: 'app-type-prestations',
  templateUrl: './type-prestations.component.html',
  styleUrls: ['./type-prestations.component.scss']
})
export class TypePrestationsComponent implements OnInit {

	@ViewChild("dd", {static: false}) table;
	types: any[];
	clonedType: { [s: number]: any; } = {};
	index: number;
	lastNewId: number = -1;
	units: any[] = [
		{
			value: 1,
			label: 'Heure d\'expertise'
		},
		{
			value: 2,
			label: 'Rapport Page'
		},
		{
			value: 3,
			label: 'Heure de déplacement'
		},
		{
			value: 4,
			label: 'km'
		}
	];

	constructor(private typePrestationService: TypePrestationService,
		private tarifCodeService: TarifCodeService) { }

  	ngOnInit() {
  		this.typePrestationService.get().subscribe(t => this.types = t);
		  this.tarifCodeService.get().pipe(
			  map(t => t.map(ta => ({value: ta.id, label: ta.name})))
		  ).subscribe(t => this.units = t);
  	}

  	getUnitLabel(id: number) {
  		return this.units.find(u => u.value === id).label;
  	}

    onRowEditInit(data: any, index: number) {
    	this.index = index;
       this.clonedType[data.id] = Object.assign({},{...data});
    }

    onRowEditCancel(data: any, index: number) {
        if (this.clonedType[data.id]) {
            this.types[index] = this.clonedType[data.id];
            delete this.clonedType[data.id];
        } else {

        }
    }
  	onRowEditSave(data: any) {
  		this.typePrestationService.save(data).subscribe(t => {
  			if (this.types.findIndex(ts => ts.id === t.id ) >= 0) {
  				this.types = this.types.map(ts => (ts.id === t.id ? t : ts));
  			} else {
  				this.types = this.types.concat(t);
  			}
	  		delete this.clonedType[data.id];
  		});
  	}

  	addType() {

  		this.lastNewId--;
  		this.types = this.types.concat({
  			id: this.lastNewId,
  			name: '',
  			unit: 1
  		});
  		this.table.editingRowKeys[this.lastNewId] = true;

  	}

}

